import React from "react";
import { controlPropTypes } from "../../formhelpers";
import PropTypes from "prop-types";
import FileFieldRow from "./FileFieldRow";
import { processKeyName } from "../utils/keyEvents";

export default class FileField extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onFileUpload = this.onFileUpload.bind(this);
        this.onFileOpen = this.onFileOpen.bind(this);
        this.onFileRemove = this.onFileRemove.bind(this);
    }

    onFocus(e) {
        const { descriptor, onFocus } = this.props;
        onFocus && onFocus(e, descriptor);
    }

    onBlur(e) {
        const { descriptor, onBlur } = this.props;
        onBlur && onBlur(e, descriptor);
    }

    onClick(e) {
        const { descriptor, onClick } = this.props;
        onClick && onClick(e, descriptor);
    }

    onKeyDown(e) {
        const { descriptor, onKeyDown } = this.props;
        const keyDownName = processKeyName(e.key);
        if(["Enter", " "].includes(keyDownName)) {
            this.inputRef.current.click();
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        onKeyDown && onKeyDown(e, descriptor);
    }

    onFileUpload(e) {
        const { descriptor, onFileUpload } = this.props;
        onFileUpload && onFileUpload(e, descriptor, e.target.files);
    }

    onFileOpen(e, file, index) {
        const { descriptor, onFileOpen } = this.props;
        onFileOpen && onFileOpen(e, descriptor, file, index );
    }
    onFileRemove(e, file, index) {
        const { descriptor, onFileRemove } = this.props;
        onFileRemove && onFileRemove(e, descriptor, file, index );
    }

    render() {
        const {files, descriptor, style, enabled, multiSelect, readOnly} = this.props;
        const config = descriptor.config || {};
        const items =
            <div className="row">
                <div className="file-list container-fluid">
                    {files.map((file, i) =>
                        <FileFieldRow
                            key={i}
                            readOnly={readOnly}
                            onFileOpen={this.onFileOpen}
                            onFileRemove={this.onFileRemove}
                            file={file}
                            index={i}
                        />)}
                </div>
            </div>;

        if (readOnly) return items;

        return (
            <React.Fragment>
                {items}
                <div className="row">
                    <div className="col-md-6">
                        <a
                            href="#"
                            className="form-control focusable btn btn-default btn-file"
                            onClick={this.onClick}
                            onKeyDown={this.onKeyDown}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                        >
                            <span /> {" "}
                            Upload New File
                            <input
                                ref={this.inputRef}
                                type="file"
                                tabIndex="-1"
                                className="form-control"
                                onChange={this.onFileUpload}
                                disabled={!enabled}
                                style={style}
                                multiple={multiSelect || config.multiValued || false}
                            />
                        </a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

FileField.propTypes = {
    ...controlPropTypes({ multiValued: PropTypes.bool }),
    files: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            filename: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            progress: PropTypes.number.isRequired,
            filesize: PropTypes.number.isRequired,
        })
    ),
    multiValued: PropTypes.bool,
    onFileOpen: PropTypes.func, //...(event, descriptor, file, index)
    onFileRemove: PropTypes.func, //...(event, descriptor, file, index)

    // html control event methods
    onFileUpload: PropTypes.func.isRequired, //...(event, descriptor)
    readOnly: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/FileField/FileField.js